import { digitsEnToFa } from 'persian-tools2';
import styled from 'styled-components';

export const TimerComponent = ({ timerHandler, isRunning, time }) => {
  return (
    <StyledText>
      <div>
        <span onClick={timerHandler}>ارسال دوباره</span>
        {isRunning && <p>{digitsEnToFa(time)}</p>}
      </div>
    </StyledText>
  );
};

const StyledText = styled.div`
  div {
    position: absolute;
    margin-top: 55px;
    display: flex;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #707070;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  p {
    width: 45px;
    margin-right: 5px;
  }
`;
